import { render, staticRenderFns } from "./Editor-DeleteProfile.vue?vue&type=template&id=7ac4c265"
import script from "./Editor-DeleteProfile.vue?vue&type=script&lang=ts"
export * from "./Editor-DeleteProfile.vue?vue&type=script&lang=ts"
import style0 from "./Editor-DeleteProfile.vue?vue&type=style&index=0&id=7ac4c265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports